import { useState } from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export const Header = ({ onResumeClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  const handleWorkClick = (e) => {
    if (isHomePage) {
      // On homepage, scroll to work section
      e.preventDefault();
      const workSection = document.getElementById('work');
      if (workSection) {
        workSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // On other pages, navigate to homepage with hash
      e.preventDefault();
      navigate('/#work');
      // Small delay to allow navigation, then scroll
      setTimeout(() => {
        const workSection = document.getElementById('work');
        if (workSection) {
          workSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 glass border-b border-border-subtle">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <nav className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo with whimsy animation */}
          <Link 
            to="/" 
            className="flex items-center gap-2 group"
            data-testid="logo-link"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <span className="font-heading text-xl lg:text-2xl font-semibold text-foreground-primary tracking-tight">
              Jesse Wilson
            </span>
            <motion.div
              animate={{ 
                rotate: isHovered ? 180 : 0,
                scale: isHovered ? 1.2 : 1
              }}
              transition={{ duration: 0.5, ease: "easeInOut" }}
            >
              <Sparkles 
                className="w-4 h-4 lg:w-5 lg:h-5 text-accent" 
                strokeWidth={1.5}
              />
            </motion.div>
          </Link>

          {/* Navigation */}
          <div className="flex items-center gap-6 lg:gap-8">
            <a 
              href="/#work"
              onClick={handleWorkClick}
              className="font-body text-sm text-foreground-secondary hover:text-foreground-primary transition-colors duration-200"
              data-testid="work-nav-link"
            >
              Work
            </a>
            <button
              onClick={onResumeClick}
              className="font-body text-sm px-5 py-2 rounded-full bg-foreground-primary text-background-primary hover:bg-accent transition-colors duration-200"
              data-testid="resume-button"
            >
              Resume
            </button>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
